<template>
  <v-container>
    <v-row wrap>

      <v-col cols="12" md="6" lg="4" v-for="(desc, amenity) in amenities" :key="amenity">
        <v-card flat :key="amenity" class="fill-height">
          <v-row no-gutters align="center" class="fill-height">

            <v-col style="min-width:148px; max-width:148px">
              <div style="border-radius:50%; border:2px solid lightgrey">
                <v-avatar class="ma-7" size="90" tile>
                  <img :src="get_icon(amenity)">
                </v-avatar>
              </div>
            </v-col>

            <v-col>
              <v-card-text class="text-left title font-weight-regular" v-text="desc"></v-card-text>
            </v-col>

          </v-row>
        </v-card>
      </v-col>

    </v-row>

  </v-container>
</template>

<script>

export default {
  name: 'Amenities',

  data: () => ({
    amenities: {
      "room-sharing":       "At most three people share a room. Private rooms are available as well!",
      plate:                "Nutritious food included with the accommodation",
      bed:                  "No bunk beds! Everyone gets an individual bed.",
      "air-conditioner":    "Rooms are equipped with air conditioners (AC)",
      desk:                 "Study desk and chair are provided in each room",
      wardrobe:             "Each person gets their own 6x3 wardrobe within the room",
      wifi:                 "Free high speed internet available in every room",
      tv:                   "TV provided in each and every room",
      cctv:                 "All common areas are secured with CCTV cameras for protection -- respecting your privacy!",
      security:             "24x7 guarded by security personnel",
      bathroom:             "Every room has an attached bathroom. At most three people share the same.",
      shower:               "Separate shower area within the bathroom to keep it dry and clean all the time",
      "water-heater":       "Each bathroom is equipped with a water heater",
      "house-keeping":      "House keeping facility to keep the accommodation immaculate",
      "washing-machine":    "Washing machines available in the building for easy laundry",
      gym:                  "A modern gym available within the building",
      "electric-generator": "Power backup provided round the clock",
      lift:                 "Lift access to all the floors",
      parking:              "Parking space available within the building",
      "drinking-water":     "Each floor is equipped with a drinking water dispenser",
    },
  }),

  methods: {
    get_icon(name) {
      var icons = require.context("../assets/icons", false, /\.svg$/)
      return icons("./" + name + ".svg")
    }
  },
};
</script>
